import React from 'react';

const BulkComponentLoadable = React.lazy(() => import('./BulkComponent'));

export{
    BulkComponentLoadable
}